<template>
    <div :style="cardStyle" id="featureInfoContainerRoot">
        <slot id="container"></slot>
        <OpenIcon  :color="plusColor" :style="iconPosition" id="icon"/>
    </div>
</template>

<script>
    import OpenIcon from "../icons/OpenIcon";

    export default {
        name: "FeatureInfoContainerCard",
        components: {OpenIcon},
        props: {
            backgroundColor: {
                type: String,
                default: "#313131"
            },
            iconColor: {
                type: String,
                default: "#313131"
            },
            description: {
                type: String,
                default: ""
            },
            openIconPosition: {
                type: Number,
                default: 1
            }
        },

        computed: {
            cardStyle() {
                return {
                    'background-color': `${this.backgroundColor}`
                }
            },
            plusColor() {
                return this.iconColor
            },
            iconPosition() {
                if (this.openIconPosition === 1) {
                    return {
                        'grid-column': `${this.openIconPosition}`,
                        'justify-self': 'start'
                    }
                } else if (this.openIconPosition === 2) {
                    return {
                        'grid-column': `${this.openIconPosition}`,
                        'justify-self': 'center'
                    }
                } else {
                    return {
                        'grid-column': `${this.openIconPosition}`,
                        'justify-self': 'end'
                    }
                }
            }
        }
    }
</script>

<style lang="scss" src="../../styles/featureinfocontainercard.scss" scoped/>